export default __webpack_public_path__ + "static/media/Wombat.8262b0ae.png";